import React, { useState, useEffect } from 'react';
import PostByAgg from '../../utils/axios';
import classNames from 'classnames';

const FILTER_OPTIONS = [
    { Song: 'All', value: '0', interval_day: 0 },
    { Song: 'Last 7 Day', value: '7day', interval_day: 7 },
    { Song: 'Last 1 Month', value: '1month', interval_day: 30 },
    { Song: 'Last 3 Month', value: '3month', interval_day: 90 }
];

const TopFourSong = () => {
    const [activeFilter, setActiveFilter] = useState('0');
    const [SongData, setSongData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const selectedOption = FILTER_OPTIONS.find(opt => opt.value === activeFilter);
        const intervalDay = selectedOption ? selectedOption.interval_day : 0;
        fetchTopSongs(intervalDay);
    }, [activeFilter]);

    const fetchTopSongs = (interval_day) => {
        setLoading(true);
        PostByAgg({
            url: 'song/v1/track/top-four-songs',
            body: {
                interval_day,
                music_label_code: ''
            },
            onResponse: (res) => {
                console.log('API result Songs:', res);
                setSongData(Array.isArray(res.data.data) ? res.data.data : []);
                setLoading(false);
            },
            onError: () => {
                setSongData([]);
                setLoading(false);
            }
        });
    };

    return (
        <div className="col-12">
            <div className="mb-16 mt-8 d-flex flex-wrap justify-content-between gap-16">
                <h6 className="mb-0">Top 4 Songs</h6>
                <ul className="nav button-tab nav-pills mb-16 gap-12" role="tablist">
                    {FILTER_OPTIONS.map((opt) => (
                        <li key={opt.value} className="nav-item" role="presentation">
                            <button
                                className={classNames(
                                    'nav-link fw-semibold text-secondary-light rounded-pill px-20 py-6 border border-neutral-300',
                                    { active: activeFilter === opt.value }
                                )}
                                type="button"
                                onClick={() => setActiveFilter(opt.value)}
                            >
                                {opt.Song}
                            </button>
                        </li>
                    ))}
                </ul>
            </div>

            {loading ? (
                <div className="text-center">Loading...</div>
            ) : (
                <div className="row g-3">
                    {SongData.length > 0 ? SongData.map((item, index) => (
                        <div key={index} className="col-xxl-3 col-sm-6 col-xs-6">
                            <div className="nft-card bg-base radius-16 overflow-hidden">
                                <div className="radius-16 overflow-hidden" style={{ height: '180px' }}>
                                    <img
                                        src={item.image_url}
                                        // alt={item.release_name}
                                        className="w-100 h-100 object-fit-cover"
                                        style={{ objectFit: 'cover' }}
                                        onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = 'https://www.shutterstock.com/shutterstock/videos/1106390253/thumb/1.jpg?ip=x480';
                                        }}
                                    />
                                </div>
                                <div className="p-10">
                                    <h6 className="text-md fw-bold text-primary-light">
                                        {item.song_title}
                                    </h6>
                                    <div className="mt-10 d-flex align-items-center justify-content-between gap-8 flex-wrap">
                                        <span className="text-sm text-secondary-light fw-medium">
                                            <span className="fw-semibold">{item.release_name}</span>
                                        </span>
                                    </div>
                                    <div className="d-flex align-items-center gap-8">
                                        <img
                                            /*
                                            src="http://app.redrobot.co.id/assets/images/ORBIT2crop.png"
                                            */
                                            src="/assets/images/ORBIT2crop.png"
                                            className="w-28-px h-28-px rounded-circle object-fit-cover"
                                            alt="avatar placeholder"
                                        />
                                        <span className="text-sm text-secondary-light fw-medium">
                                            Viewer: {item.viewer}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )) : (
                        <div className="text-center w-100">No data available</div>
                    )}
                </div>
            )}
        </div>
    );
};

export default TopFourSong;
